import { render } from "./DateComponent.vue?vue&type=template&id=58134a67&scoped=true"
import script from "./DateComponent.vue?vue&type=script&lang=js"
export * from "./DateComponent.vue?vue&type=script&lang=js"

import "./DateComponent.vue?vue&type=style&index=0&id=58134a67&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58134a67"

export default script